import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { useEffect } from "react";
import { PesquisaSatisfacaoForm, PesquisaSatisfacaoSchema } from "../../../schemas/AssistenciaTecnica_cadastro/pesquisa_satisfacao";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";

/**
 * PesquisaSatisfacaoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  pesquisaSatisfacaoDropdown: DropDown[];

  onClose: () => void;
  onSubmit: (form: PesquisaSatisfacaoForm) => void;
};

export const PesquisaSatisfacaoModal = ({
  open,
  saving,
  loading,
  pesquisaSatisfacaoDropdown,
  onClose,
  onSubmit
}: Props) => {

  const hookForm = useForm<PesquisaSatisfacaoForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(PesquisaSatisfacaoSchema),
  });

  useEffect(() => {
    if (open) {
      hookForm.reset();
    }
  }, [
    open,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Registro de Atendimento"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-4 my-4">
        {/* <DefaultFormAutocomplete
          name='pesquisa'
          label='Pesquisa'
          required={true}
          options={pesquisaSatisfacaoDropdown}
          getOptionKey={x => x.id}
          getOptionLabel={x => x.title}
          reactHookForm={hookForm}
        /> */}

        <DefaultFormMultiAutocomplete
          name='pesquisas'
          label='Pesquisas'
          required={true}
          options={pesquisaSatisfacaoDropdown}
          getOptionKey={x => x.id}
          getOptionLabel={x => x.title}
          reactHookForm={hookForm}
        />

      </div>
    </BaseFormControlledModal>
  );
}